import { CardProps } from '@/components/card/types';
import { HitAllResult } from '@/components/search/types';
import { AppConfig } from '@/utils/AppConfig';
import { format } from 'date-fns/format';

export function mapVideoHit(hit: HitAllResult): CardProps {
  return {
    title: hit.title,
    category: hit.category || '',
    description: hit.description?.slice(0, 200) || '',
    callToActionUrl: {
      url: `/videos/${hit.id}`,
      slug: '',
      external: false,
    },
    duration: hit.duration_seconds ? format(new Date(hit.duration_seconds * 1000), 'HH:mm:ss') : '',
    image: hit?.thumbnailMediumUrl || '',
    imageAlt: hit?.title || '',
    titleUppercase: !hit.thumbnailMediumUrl ? true : false,
    titleCustomFont: true,
    displayDescription: !hit.thumbnailMediumUrl ? true : false,
    isoDate: hit?.date_published || '',
  };
}
